
/* injects from baggage-loader */

'use strict';

import moment from 'moment';

import $ from 'jquery';

export default class countdownController {
    constructor($log, $rootScope, $element, $timeout) {
        'ngInject';
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$element = $element;
        this.$timeout = $timeout;

        this.expireDate = null;
        this.countdown = null;
    }
    
    $onInit(){                
        this.$rootScope.$on('start:countdown', this.startCount.bind(this));
        this.$rootScope.$on('reset:stage', this.startCount.bind(this));
    }

    initializeCount(){
        this.expireDate = moment().add(this.minutes, 'minutes').format('YYYY/MM/DD HH:mm:ss');
    }
    
    startCount(){
        this.initializeCount();      

        $(this.$element).find('#countdown').countdown(this.expireDate, this.onUpdateTime.bind(this));
    }

    onUpdateTime(event){
        switch (event.type) {
            case 'update':
                this.$timeout(this.setCountdown.bind(this, event));
                break;        
            case 'finish':
                this.$timeout(this.setCountdown.bind(this, event));
                
                this.$rootScope.$emit('finish:countdown');
                break;
        }
        
    }

    setCountdown(event){
        this.countdown = event.strftime('%M:%S');
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/countdown/countdown.controller.js